import { CommentReference, CommentReferenceType, StreamComment } from '../amorg-common';
import { apiPath } from "./../amorg-common";
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";


export const getComments = async (referenceType:CommentReferenceType, referenceId:string): Promise<StreamComment[]> =>
{
    const comments:StreamComment[] = await queryAuthWrapper(`${apiPath}/comments/${referenceType}/${referenceId}`);
    return comments.map(c => ({
        ...c,
        created: new Date(c.created),
        updated: c.updated ? new Date(c.updated) : null
    }));
};

export const createComment = async (id:string, reference:CommentReference, content:string) =>
    commandAuthWrapper(`${apiPath}/comments`, 'POST',
        { id, reference, content });

export const updateComment = async (id:string, content:string) =>
    commandAuthWrapper(`${apiPath}/comments/${id}`, 'PUT',
        { content });

export const deleteComment = async (id:string) =>
    commandAuthWrapper(`${apiPath}/comments/${id}`, 'DELETE');